export const state = () => ({
  items_count: 0,
  pages_count: 0,
  results: []
})

export const mutations = {
  SET_VACANCY(state, { items_count, pages_count, results }) {
    state["items_count"] = items_count || 0
    state["pages_count"] = pages_count || 0
    state["results"] = results || []
  },

  ADD_VACANCY(state, payload) {
    state.results = [...state.results, payload]
  },

  UPDATE_VACANCY(state, payload) {
    const f = (state.results || []).findIndex(() => payload.id)

    if (f !== -1) {
      state.results = [
        ...state.results.slice(0, f),
        payload,
        ...state.results.slice(f + 1)
      ]
    }
  },

  DELETE_VACANCY(state, itemId) {
    const f = (state.results || []).findIndex((item) => item.id === itemId)

    if (f !== -1) {
      state.results = [
        ...state.results.slice(0, f),
        ...state.results.slice(f + 1)
      ]
    }
  }
}

export const getters = {}

export const actions = {
  fetch({ commit }, payload) {
    try {
      return this.$api
        .get("/jobs/list", {
          params: payload
        })
        .then((res) => {
          if (res.data) {
            commit("SET_VACANCY", res.data)
          }
          return res.data || {}
        })
        .catch((err) => {
          throw "Ошибка при получении данных, " + err
        })
    } catch (err) {
      console.error(err)
    }
  },

  create(_, arg) {
    return this.$api
      .post("/jobs/create", arg)
      .then(() => {
        // console.log("create res", res);
        // commit("ADD_VACANCY", arg);
        return true
      })
      .catch((err) => {
        console.error(err)
        return false
      })
  },

  update(_, arg) {
    return this.$api
      .put("/jobs/update/" + arg.id, arg)
      .then(() => {
        // console.log("update res", res);
        // commit("UPDATE_VACANCY", arg);
        return true
      })
      .catch((err) => {
        console.error(err)
        return false
      })
    //
  },

  createOrUpdate({ dispatch }, arg) {
    return dispatch(`${arg.id ? "update" : "create"}`, arg)
  },

  detail(_, vacancyId) {
    try {
      return this.$api
        .get("/jobs/get/" + vacancyId, {
          headers: {
            "Accept-Language": ""
          }
        })
        .then((res) => (res && res.data) || {})
        .catch((err) => {
          throw "Не удалось получить данные о вакансии " + err
        })
    } catch (err) {
      console.error(err)
      return null
    }
  },

  removeVacancy({ commit }, vacancyItem) {
    if (vacancyItem && vacancyItem.id) {
      this.$api
        .delete("/jobs/delete/" + vacancyItem.id)
        .then(() => {
          commit("DELETE_VACANCY", vacancyItem.id)
        })
        .catch((err) => {
          console.error("removeVacancy", err)
        })
    }
  }
}
